__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/test-bell-2023/";